import api from '@/services/api/config';

const path = 'v1/wareneingangspruefung/pruefaktion';

export default {
  getById: (id) => api.get(`${path}/${id}`),
  get: () => api.get(path),
};
